import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

interface FilterCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * Plain on/off filter checkbox.
 *
 * Use this rather than TriCheckbox wherever the filter can only be applied or
 * not applied. A three-state control there shows a middle state that is either
 * unreachable or a no-op click.
 */
const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ label, checked, onChange, disabled }) => (
  <FormGroup className="mb-0 d-flex align-items-center justify-content-end" check>
    <Label
      className="form-control-label mb-0 d-flex align-items-center"
      style={{ gap: ".5rem", cursor: disabled ? "default" : "pointer" }}
      check
    >
      <span>{label}</span>
      <Input
        type="checkbox"
        className="position-static m-0"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
    </Label>
  </FormGroup>
);

export default FilterCheckbox;
